import OfferUrgencyCountdownLabel from 'components/Common/Labels/OfferUrgencyCountdownLabel'
import OfferCardCarouselSection from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import React, { useContext, useMemo } from 'react'
import { firstWaveStartDate, secondWaveStartDate, thirdWaveStartDate, useBestOf2024 } from './BestOfUtils'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { BestOfCampaignRegionTags } from './BestOfConstants'
import GeoContext from 'contexts/geoContext'
import Group from 'components/utils/Group'
import LabelGroup from 'components/Luxkit/Label/LabelGroup'

function BestOfHiddenOffersCarousel() {
  const { currentRegionCode } = useContext(GeoContext)
  const bestOfConfig = useBestOf2024()
  const endDate = useMemo(() => {
    switch (bestOfConfig.wave) {
      case 'first-wave-early-access':
        return firstWaveStartDate
      case 'second-wave-early-access':
        return secondWaveStartDate
      case 'third-wave-early-access':
        return thirdWaveStartDate
      default:
        return undefined
    }
  }, [bestOfConfig])

  const title = useMemo(() => {
    switch (bestOfConfig.wave) {
      case 'first-wave-early-access':
        return 'Want early access to our ‘Best of 2024’ offers?'
      case 'second-wave-early-access':
      case 'third-wave-early-access':
        return <>Want early access to <i>more</i> ‘Best of 2024’ offers?</>
      default:
        return undefined
    }
  }, [bestOfConfig])

  const filters = useMemo<App.OfferListFilters>(() => ({
    offerTypes: ['hotel', 'tactical_ao_hotel'],
    campaigns: [BestOfCampaignRegionTags[currentRegionCode]],
    temporaryBestOfOnlyRestricted: true,
    limit: 20,
  }), [currentRegionCode])

  return <OfferCardCarouselSection
    title={title}
    subtitle={<Group direction="vertical" tabletDirection="horizontal" gap={8} verticalAlign="center">
      LuxPlus+ members unlock exclusive access to our bestselling offers before the general public!
      {endDate && <LabelGroup>
        <OfferUrgencyCountdownLabel
          isLuxPlusEarlyAccess
          endDate={endDate.format(ISO_DATE_FORMAT)}
        />
      </LabelGroup>}
    </Group>}
    filters={filters}
    tileStyle="locked-card"
  />
}

export default BestOfHiddenOffersCarousel
